import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../lib/api';
import type { HealthDto } from '../lib/types';

export function Dashboard() {
  const { data, isLoading, error } = useQuery({
    queryKey: ['health'],
    queryFn: () => apiClient.get<HealthDto>('/api/health')
  });

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-atg-navy">Welcome to RataExport</h1>
        <p className="text-slate-600 mt-1">RapidDevPlatform shell &mdash; replace this page with your feature.</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-white rounded-lg shadow border border-slate-200 p-4">
          <div className="text-xs uppercase text-slate-500">API health</div>
          {isLoading && <div className="text-slate-400">checking...</div>}
          {error && <div className="text-red-600 text-sm">unreachable</div>}
          {data && (
            <>
              <div className="text-2xl font-semibold text-emerald-600">{data.status}</div>
              <div className="text-xs text-slate-500 mt-1">{data.environment} &middot; v{data.version}</div>
            </>
          )}
        </div>
        <div className="bg-white rounded-lg shadow border border-slate-200 p-4">
          <div className="text-xs uppercase text-slate-500">Build</div>
          <div className="text-2xl font-semibold text-atg-blue">React + Vite</div>
          <div className="text-xs text-slate-500 mt-1">Tailwind &middot; TanStack Query</div>
        </div>
        <div className="bg-white rounded-lg shadow border border-slate-200 p-4">
          <div className="text-xs uppercase text-slate-500">Backend</div>
          <div className="text-2xl font-semibold text-atg-blue">.NET 10</div>
          <div className="text-xs text-slate-500 mt-1">EF Core &middot; SQL Server</div>
        </div>
      </div>
    </div>
  );
}
